import {
  initialState,
  Actions,
  State,
  GET_COMMENTS_CALENDAR,
  GET_COMMENTS_CALENDAR_SUCCESS,
  GET_COMMENTS_CALENDAR_ERROR,
  RESET_GET_COMMENTS_CALENDAR,
} from "../../types/calendar/getComments";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_COMMENTS_CALENDAR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_COMMENTS_CALENDAR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_COMMENTS_CALENDAR_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_COMMENTS_CALENDAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
